import react from 'react'
import styled from 'styled-components'

type ButtonColor = 'default' | 'primary'
const COLOR_LIST = {
  default: {
    background: '#ffffff',
    font: '#000000',
  },
  primary: {
    background: '#ff540f',
    font: '#ffffff',
  },
}
type ButtonSize = 'large' | 'medium'
const BUTTON_SIZE = {
  large: {
    padding: '14px 30px 14px 31px',
  },
  medium: {
    padding: '8px 30px 8px 31px',
  },
}
interface WrapperProps {
  $size: ButtonSize
  $block: boolean
  $color: ButtonColor
  $outline: boolean
}

const Wrapper = styled.button<WrapperProps>`
  padding: ${(props) => BUTTON_SIZE[props.$size].padding};
  border-radius: 8px;
  background-color: ${(props) => COLOR_LIST[props.$color].background};
  color: ${(props) => COLOR_LIST[props.$color].font};
  border: 1px solid #d6d6d6;
  font-size: 16px;
  outline: none;
  cursor: pointer;
  display: ${(props) => (props.$block ? 'block' : 'inline-block')};
  width: ${(props) => (props.$block ? '100%' : 'auto')};
  border: ${(props) => (props.$outline ? '1px solid #d6d6d6' : 'none')};
  &:disabled {
    background-color: #f5f5f5;
    color: #666666;
    cursor: not-allowed;
  }
`

interface Props {
  color?: ButtonColor
  size?: ButtonSize
  block?: boolean
  outline?: boolean
  className?: string
  children: JSX.Element | string | React.ReactNode
  disabled?: boolean
  onClick?: (e: react.MouseEvent<HTMLButtonElement>) => void
}
const AButton: react.FC<Props> = ({
  onClick,
  block = false,
  outline = false,
  color = 'default',
  size = 'medium',
  disabled,
  className,
  children,
}) => {
  return (
    <Wrapper
      $size={size}
      $color={color}
      $block={block}
      $outline={outline}
      disabled={disabled}
      className={className || ''}
      onClick={onClick}
    >
      {children}
    </Wrapper>
  )
}

export default AButton
